$directions: rtl, ltr, ttb, btt;
$drawer-padding: 16px;
$drawer-dragger-size: 8px;

.#{$namespace}-overlay.is-drawer {
	overflow: hidden;
}

.#{$namespace}-drawer {
	position: absolute;
	box-sizing: border-box;
	background-color: $white-color;
	display: flex;
	flex-direction: column;
	box-shadow: 0 12px 32px alpha-color($black-color, 12%);
	transition: all 0.3s;

	&__sr-focus:focus {
		outline: none;
	}

	&__header {
		align-items: center;
		color: $text-primary-color;
		display: flex;
		padding: $drawer-padding;
		padding-bottom: 0;
		overflow: hidden;
		gap: 8px;

		& > :first-child {
			flex: 1;
		}
	}

	&__title {
		margin: 0;
		flex: 1;
		line-height: 1.4;
		font-size: calc(#{$font-size} + 2px);
		font-weight: 600;
		color: $text-primary-color;
	}

	&__footer {
		padding: $drawer-padding;
		padding-top: 10px;
		text-align: right;
		overflow: hidden;

		.#{$namespace}-button + .#{$namespace}-button {
			margin-left: 12px;
		}
	}

	&__close-btn {
		display: inline-flex;
		padding: 0;
		border: none;
		cursor: pointer;
		font-size: 16px;
		color: $text-placeholder-color;
		background-color: transparent;
		outline: none;
		line-height: 1;

		&:hover {
			color: color-token(primary);
		}
	}

	&__body {
		flex: 1;
		padding: $drawer-padding;
		overflow: auto;
		color: $text-secondary-color;
		font-size: $font-size;
		word-break: break-word;

		& > * {
			box-sizing: border-box;
		}
	}

	&.is-dragging {
		transition: none;
	}

	&__dragger {
		position: absolute;
		background-color: transparent;
		user-select: none;
		transition: all 0.2s;

		&::before {
			content: '';
			position: absolute;
			background-color: transparent;
			transition: all 0.2s;
		}

		&:hover::before {
			background-color: color-token(primary);
		}
	}

	&.ltr,
	&.rtl {
		height: 100%;
		top: 0;
		bottom: 0;

		> .#{$namespace}-drawer__dragger {
			height: 100%;
			width: $drawer-dragger-size;
			top: 0;
			bottom: 0;
			cursor: ew-resize;

			&::before {
				top: 0;
				bottom: 0;
				width: 3px;
			}
		}
	}

	&.ttb,
	&.btt {
		width: 100%;
		left: 0;
		right: 0;

		> .#{$namespace}-drawer__dragger {
			width: 100%;
			height: $drawer-dragger-size;
			left: 0;
			right: 0;
			cursor: ns-resize;

			&::before {
				left: 0;
				right: 0;
				height: 3px;
			}
		}
	}

	&.ltr {
		left: 0;

		> .#{$namespace}-drawer__dragger {
			right: 0;

			&::before {
				right: -2px;
			}
		}
	}

	&.rtl {
		right: 0;

		> .#{$namespace}-drawer__dragger {
			left: 0;

			&::before {
				left: -2px;
			}
		}
	}

	&.ttb {
		top: 0;

		> .#{$namespace}-drawer__dragger {
			bottom: 0;

			&::before {
				bottom: -2px;
			}
		}
	}

	&.btt {
		bottom: 0;

		> .#{$namespace}-drawer__dragger {
			top: 0;

			&::before {
				top: -2px;
			}
		}
	}
}

.#{$namespace}-modal-drawer {
	&.is-penetrable {
		pointer-events: none;

		.#{$namespace}-drawer {
			pointer-events: auto;
		}
	}
}

.#{$namespace}-drawer-fade {
	&-enter-active,
	&-leave-active {
		transition: all 0.3s;
	}

	&-enter-from,
	&-enter-active,
	&-enter-to,
	&-leave-from,
	&-leave-active,
	&-leave-to {
		overflow: hidden !important;
	}

	&-enter-from,
	&-leave-to {
		&:not(.is-modal-no-fade) {
			background-color: transparent !important;
		}

		@each $direction in $directions {
			.#{$direction} {
				@if $direction == ltr {
					transform: translateX(-100%);
				}

				@if $direction == rtl {
					transform: translateX(100%);
				}

				@if $direction == ttb {
					transform: translateY(-100%);
				}

				@if $direction == btt {
					transform: translateY(100%);
				}
			}
		}
	}
}
